import { useOidc } from '@axa-fr/react-oidc';
import { Col, Row } from "reactstrap"
import { IWhatsNextProps } from './WhatsNext';
import { Link } from 'react-router-dom';
import { NavigationDetail } from './NavigationDetail';

export interface ILinkDetails {
    linkTitle: string,
    linkName: string,
    linkColorClassName: string,
    orderClassName: string,
    url: string,
}

export const NavigationBox = ({ isSampleFleet, isAuthenticated }: IWhatsNextProps) => {
    const { login } = useOidc();

    return (
        <div className="navigationBoxContainer">
            <Row>
                <Col className="navSubHeader">
                    {isAuthenticated ? (
                        <p>If you need your organization's approval before you sign up for a full fleet assessment,
                            these resources can support your case for electrification.</p>
                    ) : (
                            <p>If you need your organization's approval before you sign up for a full fleet assessment, these resources can support your
                                case for electrification. To explore funding sources and view our catalog of electric vehicles please <a key="Register" onClick={() => login("/Login")} href="/login">register for a free account.</a></p>
                    )}
                </Col>
            </Row>
            <Row>
                <Col className="navThreeLinks">
                    {isAuthenticated ? (
                        isSampleFleet ? (
                            <Row className="whatsNextLinkSet">
                                <NavigationDetail linkTitle="Fleet Estimator" linkName="See Savings" linkColorClassName="blue" orderClassName="first" url="/CreateFleet" />
                                <NavigationDetail linkTitle="Funding Sources" linkName="Explore" linkColorClassName="green" orderClassName="middle" url="/FundingSources" />
                                <NavigationDetail linkTitle="EV Catalog" linkName="View" linkColorClassName="teal" orderClassName="last" url="/VehicleCatalog" />
                            </Row>
                        ) : (
                                <Row className="whatsNextLinkSet">
                                    <NavigationDetail linkTitle="Funding Sources" linkName="Explore" linkColorClassName="green" orderClassName="first" url="/FundingSources" />
                                    <NavigationDetail linkTitle="EV Catalog" linkName="View" linkColorClassName="teal" orderClassName="middle" url="/VehicleCatalog" />
                                    <NavigationDetail linkTitle="About EVs" linkName="Learn more" linkColorClassName="blue" orderClassName="last" url="/ElectrificationBasics" />
                            </Row>
                        )) : (
                            <Row className="whatsNextLinkSet">
                                <NavigationDetail linkTitle="Fleet Estimator" linkName="Get Access" linkColorClassName="blue" orderClassName="first" url="/Login" />
                                <NavigationDetail linkTitle="Funding Sources" linkName="Get Access" linkColorClassName="green" orderClassName="middle" url="/Login" />
                                <NavigationDetail linkTitle="EV Catalog" linkName="Get Access" linkColorClassName="teal" orderClassName="last" url="/Login" />
                            </Row>
                    )
                    }
                </Col>
            </Row>
            <Row>
                <Col className="navContactUs">
                    <p>Questions? <Link className="accent-link" to="/ContactUs" target="_self">Contact Us</Link></p>
                </Col>
            </Row>
        </div>
    )
}
